<template>
  <el-input
    ref="input"
    v-model="innerValue"
    :disabled="disabled"
    @blur="handleBlur"
    @focus="handleFocus"
    @input="e=>$emit('input',e)"
  />
</template>

<script>
import numeral from 'numeral'
export default {
  name: 'AutoNumberInput',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [Number, String],
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    precision: {// 保留几位小数
      type: [Number, String],
      default: () => 0
    },
    min: {// 保留几位小数
      type: Number,
      default: () => null
    },
    enforceMin: { // 当输入的值是空时，设置成最小值 支持0
      type: Boolean,
      default: () => false
    },
    max: {// 保留几位小数
      type: Number,
      default: () => null
    }
  },
  data() {
    return {
      innerValue: null,
      timer: null
    }
  },
  watch: {
    value(newVal) {
      // value改变时格式化显示数据
      this.innerValue = this.formatVal(newVal)
    }
  },
  created() {
    // 初始化显示数据
    this.innerValue = this.formatVal(this.value)
  },
  methods: {
    handleFocus() {
      this.$emit('focus')
    },
    handleBlur() {
      const { min, max } = this
      let val = parseFloat(this.innerValue) || ''
      if (this.enforceMin && !val) {
        val = min || 0
      }
      // 根据最大最小值改变用户输入值
      if (((min || min === 0) || (max || max === 0)) && val !== '') {
        if ((min || min === 0) && (max || max === 0)) {
          if (min < max) {
            if (val < min) {
              val = min
            }
            if ((val > max)) {
              val = max
            }
          }
        } else {
          if ((min || min === 0) && val < min) {
            val = min
          }
          if ((max || max === 0) && val > max) {
            val = max
          }
        }
      }
      this.innerValue = val
      let newVal = val ? parseFloat(this.formatVal(val)) : null
      if (this.enforceMin && val === 0) {
        newVal = 0
      }
      if ((newVal || 0) !== (Number(this.value) || 0)) {
        this.$emit('change', newVal)
      }
      // 格式化后的值如果与原值相同不会触发变化，手动触发
      if (newVal && newVal === this.value) {
        this.innerValue = this.formatVal(newVal)
      }
      this.$emit('blur')
    },
    formatVal(e) {
      // 根据配置保留小数位
      let precisionStr = '0'
      if (Number(this.precision)) {
        precisionStr += '.'
        for (let i = 0; i < Number(this.precision); i++) {
          precisionStr += '0'
        }
      }
      let v = e ? numeral(e).format(precisionStr) : ''
      if (this.enforceMin && e === 0) {
        v = 0
      }
      return v
    }
  }
}
</script>

<style scoped>

</style>
